
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.043 14.438l.472-9.995h.683a.517.517 0 000-1.032h-2.987V2.386c0-.978-.663-1.614-1.716-1.614H5.938c-1.052 0-1.709.636-1.709 1.614V3.41H1.256a.527.527 0 00-.513.52c0 .28.24.512.513.512h.683l.472 10.001c.048.985.697 1.607 1.682 1.607h6.268c.978 0 1.634-.63 1.682-1.613zM5.323 2.454c0-.39.287-.663.698-.663H8.42c.417 0 .704.273.704.663v.957h-3.8v-.957zM4.195 15.025c-.396 0-.69-.3-.71-.697l-.48-9.885h8.416l-.451 9.885c-.02.403-.308.697-.711.697H4.195zm5.059-1.203c.225 0 .396-.184.403-.444l.205-7.219c.007-.26-.17-.451-.403-.451-.212 0-.39.198-.396.444l-.206 7.226c-.006.246.164.444.397.444zm-4.054 0c.233 0 .404-.198.397-.444l-.205-7.226c-.007-.246-.192-.444-.404-.444-.232 0-.403.191-.396.451l.212 7.219c.007.26.17.444.396.444zm2.44-.444V6.152c0-.246-.184-.444-.41-.444-.225 0-.417.198-.417.444v7.226c0 .246.192.444.417.444.22 0 .41-.198.41-.444z","fill":"#AAB4C0"}})])
          )
        }
      }
    